import http from "@/utils/httpRequest";

// 查询进度
export const apiGetUserCountInfo = ({prjId, activityCode}) => {

    return http.post('/project/workflow/getUserCountInfo', {
        prjId: prjId,
        activityCode: activityCode
    }, { baseURL })
}

export const apiGetFlowUserInfos = ({prjId, activityCode}) => {

    return http.post('/project/workflow/getFlowUserInfos', {
        prjId: prjId,
        activityCode: activityCode
    }, { baseURL })
}